import type { LocationState } from '@core/Entities/Search/LocationState.entity';
import { locationApiURL } from '@core/Environment/Variables';

import { UK_POSTCODE_REGEX } from '../../Constants/Validations';
import type { PostcodeLookupResp } from '../../Entities/Location/postcodeLookup.entity';
import { formatUkPostcode } from '../../Utils/Location/FormatUkPostcode';
import { fetchJson } from '../Fetch/FetchJson';

export const validatePostcode = async (value: string) => {
  const postcode = formatUkPostcode(value);
  if (!UK_POSTCODE_REGEX.test(postcode))
    return { isValid: false, error: true, location: { lat: 0, lon: 0 } };

  try {
    const data = await fetchJson<PostcodeLookupResp>(`${locationApiURL}/postcodes/${postcode}`);

    if (data?.status === 200 && data.result) {
      return {
        isValid: true,
        error: false,
        location: { lat: data.result.latitude, lon: data.result.longitude },
      } as LocationState;
    }

    return { isValid: false, error: true, location: { lat: 0, lon: 0 } };
  } catch (_error) {
    return { isValid: false, error: true, location: { lat: 0, lon: 0 } };
  }
};

export default validatePostcode;
